var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14L5.83333 11.6667M5.83333 11.6667L14 3.5L22.1667 11.6667M5.83333 11.6667V23.3333C5.83333 23.6428 5.95625 23.9395 6.17504 24.1583C6.39383 24.3771 6.69058 24.5 7 24.5H10.5M22.1667 11.6667L24.5 14M22.1667 11.6667V23.3333C22.1667 23.6428 22.0438 23.9395 21.825 24.1583C21.6062 24.3771 21.3094 24.5 21 24.5H17.5M10.5 24.5C10.8094 24.5 11.1062 24.3771 11.325 24.1583C11.5437 23.9395 11.6667 23.6428 11.6667 23.3333V18.6667C11.6667 18.3572 11.7896 18.0605 12.0084 17.8417C12.2272 17.6229 12.5239 17.5 12.8333 17.5H15.1667C15.4761 17.5 15.7728 17.6229 15.9916 17.8417C16.2104 18.0605 16.3333 18.3572 16.3333 18.6667V23.3333C16.3333 23.6428 16.4562 23.9395 16.675 24.1583C16.8938 24.3771 17.1906 24.5 17.5 24.5M10.5 24.5H17.5",
    stroke: "#FDFBFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHome);
export default __webpack_public_path__ + "static/media/menu-home.5d6c7500a2cfc69d78a3ec8df7732029.svg";
export { ForwardRef as ReactComponent };